export default "__VITE_ASSET__Du$0USSK__"